import React from "react";
import ReactDOM from "react-dom";
import Site from "./Site";
import "./style.css";

ReactDOM.render(<Site/>, document.getElementById("app"))